import Request from "../../../helpers/Request";
import {
  documentTypes,
  definitionState,
  activityState,
} from "../../../assets/constants";

export const DOCUMENT_TYPES_URL = "/api/enums/osgb-izleme/document-types";
export const LIMIT_URL = "/api/osgb-izleme/isg-professionals/limit";

const unwrap = (payload) =>
  payload && payload.content !== undefined ? payload.content : payload;

export function extractEnumValues(payload) {
  const source = unwrap(payload);
  if (!Array.isArray(source)) {
    return [];
  }
  return source
    .map((entry) => (typeof entry === "string" ? entry : entry?.name))
    .filter(Boolean);
}

export function toDocumentTypeLookup(values) {
  if (!values.length) {
    return documentTypes;
  }
  return values.reduce(
    (lookup, value) => ({ ...lookup, [value]: documentTypes[value] || value }),
    {}
  );
}

export function extractLimit(payload) {
  const source = unwrap(payload);
  if (!source || typeof source !== "object" || source.success === false) {
    return null;
  }
  const { used, definedLimit } = source;
  if (typeof used !== "number" || typeof definedLimit !== "number") {
    return null;
  }
  return { used, limit: definedLimit };
}

export default async function GetOptions() {
  const resp = await Request("get", DOCUMENT_TYPES_URL);
  const values = resp?.status === 200 ? extractEnumValues(resp.data) : [];
  return {
    documentTypes: toDocumentTypeLookup(values),
    definitionState,
    activityState,
  };
}

export async function GetLimit() {
  const resp = await Request("get", LIMIT_URL);
  return resp?.status === 200 ? extractLimit(resp.data) : null;
}
